import * as React from 'react';
import { motion, useAnimation } from 'motion/react';

function ToggleLeft({ size = 28, toggled = false, animateOnHover = false, onClick, className, ...props }) {
  const jiggleControls = useAnimation();

  const handleMouseEnter = async () => {
    if (!animateOnHover) return;
    const dir = toggled ? -2 : 2;
    await jiggleControls.start({
      x: [0, dir, -dir * 0.4, 0],
      transition: { duration: 0.45, ease: 'easeInOut' },
    });
  };

  const handleMouseLeave = () => {
    jiggleControls.stop();
    jiggleControls.set({ x: 0 });
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : undefined }}
      {...props}
    >
      <rect width={20} height={12} x={2} y={6} rx={6} ry={6} />
      {/* motion.g handles hover jiggle; motion.circle handles toggled position */}
      <motion.g animate={jiggleControls} initial={{ x: 0 }}>
        <motion.circle
          cy={12}
          r={3}
          animate={{ cx: toggled ? 16 : 8 }}
          initial={{ cx: toggled ? 16 : 8 }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
        />
      </motion.g>
    </svg>
  );
}

export { ToggleLeft, ToggleLeft as ToggleLeftIcon };
